import { render, staticRenderFns } from "./VgmPop.vue?vue&type=template&id=12843dc3&scoped=true"
import script from "./VgmPop.vue?vue&type=script&lang=js"
export * from "./VgmPop.vue?vue&type=script&lang=js"
import style0 from "./VgmPop.vue?vue&type=style&index=0&id=12843dc3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12843dc3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12843dc3')) {
      api.createRecord('12843dc3', component.options)
    } else {
      api.reload('12843dc3', component.options)
    }
    module.hot.accept("./VgmPop.vue?vue&type=template&id=12843dc3&scoped=true", function () {
      api.rerender('12843dc3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/VgmPop.vue"
export default component.exports